const module = { name: 'movie/overview/mediaCarouselUI', exports: {} }; const exports = module.exports;



import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as link } from 'require-core';



import { Splide as Splide } from 'require-core';



import { swig as swig } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { default as movie_shared_iconicImgUI_updateIconicImg } from 'swug-fdRequire-call:movie/shared/iconicImgUI';

const { updateIconicImg } = movie_shared_iconicImgUI_updateIconicImg;


const Selectors = {
    DEFAULT_ICONIC_IMG: '#mop-iconic-img-default',
    DEFAULT_ICONIC_IMG_BACKGROUND: '#mop-iconic-img-default-background',
    GALLERY: '#movie-detail-dropdown-media-gallery',
    PHOTOS_SECTION: '#movie-details-photos-container',
    SPLIDE_CAROUSEL: 'movie-detail-media-gallery',
    IMG_BTNS: '.js-gallery-modal-btn',
    GALLERY_CONTENT: '#movie-gallery-modal-content',
    GALLERY_MODAL: '#movie-gallery-modal',
}


const Styles = {
    HIDE: 'hide',
}
function onOpenClick(imgSelected) {
    const imageData = {
        image: imgSelected.imageUri.size.full,
        altText: imgSelected.altText,
        caption: imgSelected.caption,
    };
    const markup = swig.render('_moviePhotoGalleryImage', imageData);
    document.querySelector(Selectors.GALLERY_CONTENT).innerHTML = markup;
    track({
        event: EventTypes.PHOTO_CLICKS
    });
}
function onFetchDone(data) {
    if (!data?.images?.length) {
        return document.querySelector(Selectors.PHOTOS_SECTION)?.classList.add(Styles.HIDE);
    }
    const viewModel = {
        id: Selectors.SPLIDE_CAROUSEL,
        content: swig.render('_mediaGalleryItems', {
            ...data,
            moviePhotosURI: link.moviePhotosPosters({
                id: data.movieInfo.id,
                title: data.movieInfo.sluggedTitle
            })
        }),
    };
    document.querySelector(Selectors.GALLERY).innerHTML = swig.render('_splideCarousel', viewModel);
    updateIconicImg(data, 500);
    modal.init(Selectors.IMG_BTNS, Selectors.GALLERY_MODAL);
    document.querySelectorAll(Selectors.IMG_BTNS).forEach(btn => {
        btn.addEventListener('click', () => {
            const btnId = btn.getAttribute('data-image-index');
            const imgSelected = data.images[btnId - 1];
            onOpenClick(imgSelected);
        });
    });
    new Splide(`#${Selectors.SPLIDE_CAROUSEL}-wrap`, {
        fixedWidth: '127px',
        fixedHeight: '120px',
        slideFocus: false,
        pagination: false,
    }).mount();
}
function onFetchFail(data) {
    debugLog.error(module.name, 'fetch failed', data);
    document.querySelector(Selectors.PHOTOS_SECTION)?.classList.add(Styles.HIDE);
}
function attach(movieID) {
    if (!document.querySelector(Selectors.GALLERY)) {
        return debugLog.warn(module.name, 'gallery missing', Selectors.GALLERY);
    }
    xhr.ajax({
        method: 'GET',
        url: link.napiMovieCarousel({ id: movieID }),
    })
        .done(onFetchDone)
        .fail(onFetchFail);
}
module.exports = {
    attach
};
export default module.exports;